import { useCallback } from 'react'

import { getAppRoutes } from '../../reduxes/slices/routes/selectors'
import { useSelectorDelegateStore } from '../../reduxes/stores/root_store/hooks'
import { useFindRouteMatch } from './use_find_route_match'

export const useFindAppRouteMatch = () => {
  const appRoutes = useSelectorDelegateStore(getAppRoutes)
  const findRouteMatch = useFindRouteMatch()

  return useCallback(
    (pathname: string): any => {
      const { match } = findRouteMatch(appRoutes, pathname) || {}
      return match
    },
    [findRouteMatch, appRoutes],
  )
}
